import React from 'react'
import { createPortal } from 'react-dom'

const PORTAL = document.getElementById('portal')

const Portal = ({ children }) => createPortal(children, PORTAL)

export default Portal
